// RIENTRO E FRECCETTA COME NELLO SCENE EDITOR (prototipo, utente 2026-10-20): 15px a livello, freccetta in 16px.
const LEVEL_INDENT_PX = 15;
export const COMPOSER_CHEVRON_SLOT_PX = 16;
const CHEVRON_SLOT_PX = COMPOSER_CHEVRON_SLOT_PX;

export const getComposerAttributeIndent = (level: number): number => level * LEVEL_INDENT_PX;

/** Leaves have no chevron, but must start to the right of their parent attribute. */
export const getComposerLeafIndent = (attributeLevel: number): number => getComposerAttributeIndent(attributeLevel + 1) + CHEVRON_SLOT_PX;
